module.exports = __webpack_public_path__ + "img/quality.575b411.webp";